import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbNavModule, NgbDropdownModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { DataTablesModule } from 'angular-datatables';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AgGridModule } from 'ag-grid-angular';

import { SettingsRoutingModule } from './settings-routing.module';
import { ConfigureSettingsComponent } from 'src/app/components/settings/configure.component';

import { NotificationsService } from 'src/app/services/notifications.service';
import { EventTableComponent } from 'src/app/components/settings/event-table';


@NgModule({
  declarations: [
    ConfigureSettingsComponent,
    EventTableComponent
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgSelectModule,
    // DataTablesModule,
    NgbPaginationModule,
    CKEditorModule,
    AgGridModule,
  ],
  exports: [
    ConfigureSettingsComponent,
    EventTableComponent
  ],
  providers: [
    NotificationsService
  ]
})
export class SettingsModule { }
